let cookies

export const getCookie = name => {
  if (cookies) {
    return cookies[name]
  }

  cookies = {}
  const cookieStrings = document.cookie.split('; ')

  cookieStrings.forEach(cookieString => {
    const [currName, currValue] = cookieString.split('=')
    cookies[currName] = currValue
  })

  return cookies[name]
}

export const setCookie = (name, value, days = 1000) => {
  let expires = ''
  value = encodeURIComponent(value)
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    expires = `; expires=${date.toGMTString()}`
  }
  document.cookie = `${name}=${value}${expires}; path=/`
}
